import { render } from "./DonationStoreListView.vue?vue&type=template&id=531c5d30&scoped=true"
import script from "./DonationStoreListView.vue?vue&type=script&lang=js"
export * from "./DonationStoreListView.vue?vue&type=script&lang=js"

import "./DonationStoreListView.vue?vue&type=style&index=0&id=531c5d30&scoped=true&lang=css"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-531c5d30"]])

export default __exports__